export default function tagRecordings(tagsArray) {
  if (typeof (hj) === 'undefined') {
    window.hj = window.hj || ((...args) => { (hj.q = hj.q || []).push(args); });
  }

  if (tagsArray && typeof (hj) !== 'undefined') {
    try {
      // Hotjar has a limit of 50 characters per tag
      const truncatedArray = tagsArray.map((tag) => tag.substring(0, 49));
      hj('tagRecording', truncatedArray);
    } catch {
      // proceed without tagging the recording
    }
  }
}
